import React from 'react';
import './aboutus.css'; 

const alumniData = [
  // Diploma in Optometry Alumni
  { name: "M. Suranga De Silva", id: "741322323V", image: "/diploma/053.jpg" },
  { name: "W. Anura Shantha Perera", id: "661830719V", image: "/diploma/052.jpg" },
  { name: "B.L. Geetha Rupini Wijesundara", id: "795161473V", image: "DO3.jpg" },
  { name: "K.M.G. Dilrukshi Dias", id: "866031240V", image: "/diploma/050.jpg" },
  { name: "Nishamani Duruge", id: "", image: "/diploma/075.jpg" },

  { name: "A.D. Isuru Sampath", id: "", image: "/diploma/071.jpg" },
  { name: "R. Sasikaran", id: "760640158V", image: "/diploma/060.jpg" },
  { name: "K.L.M. Rodrigo", id: "940812011V", image: "/diploma/079.jpg" },
  { name: "G. Nisansala S. Fernando", id: "815222415V", image: "/diploma/040.jpg" },
  { name: "W.I. Nadeeshani", id: "94758112V", image: "CO26.jpg" },

  { name: "N. Arul Kumar", id: "741810123V", image: "/diploma/066.jpg" },
  { name: "B. Prasad Gomis", id: "690831309V", image: "/diploma/064.jpg" },
  { name: "N. Udeni Gurusinghe", id: "748155722V", image: "/diploma/043.jpg" },
  { name: "K. Dayalan", id: "651431590V", image: "/diploma/045.jpg" },
  { name: "Asanka Thilana Samaratunga", id: "870451946V", image: "DO9.jpg" },

  { name: "Thenuja H. Samarasinghe", id: "877062449V", image: "DO10.jpg" },
  { name: "Anil Pradhan", id: "4038609pp Nepal", image: "DO11.jpg" },
  { name: "M. Lilendra Perera", id: "950932805V", image: "/diploma/044.jpg" },
  { name: "B.W.D.T. Priyantha", id: "711370781V", image: "DO13.jpg" },
  { name: "L. Sumith Wijesundara Bandara", id: "", image: "DO14.jpg" },

  { name: "B.A.D.T. Himidira", id: "", image: "diploma/082.jpg" },
  { name: "M. H. M. S. Pradeep Thilakarathna", id: "", image: "CO45.jpg" },
  { name: "H. Medha Rathnayake", id: "", image: "CDO36.jpg" },
  { name: "E. Dhanawardhane", id: "", image: "CDO65.jpg" },
  { name: "Sahan Perera", id: "", image: "CDO54.jpg" },

  { name: "M. W. Thushara Dilini", id: "", image: "CDO50.jpg" },
  { name: "Mahanama Dissanayake", id: "", image: "CO47.jpg" },
  { name: "Stephnie Andrea Fernando", id: "200265902700", image: "CDO59.jpg" },
  { name: "R.M. Nirmala Kumari Rathnayake", id: "877331202V", image: "DO15.jpg" },
  { name: "H.D. Sujanima R. Wijetunga", id: "925800767V", image: "/diploma/073.jpg" },

  { name: "W. Sathya N. De Mel", id: "", image: "CO27.jpg" },
  { name: "S.H.R. Premarathna", id: "643251043V", image: "/diploma/068.jpg" },
  { name: "J.A. Darshi Lekha Wijerathne", id: "856123774V", image: "/diploma/0100.jpg" },
    { name: "L. B. Sahan Chamika Perera", id: "971230967V", image: "/diploma/sahan.jpg" },
  { name: "H. Hasangi Savindya Jayasinghe", id: "200173100807 ", image: "/diploma/hasangi.jpg" },



  // Certificate in Optometry Alumni
  { name: "A. Arul Chelvan", id: "", image: "CO1.jpg" },
  { name: "Anil Sanjeewa Ratnayake", id: "692102711V", image: "CO2.jpg" },
  { name: "B.M. Sajeewanie Swarnalatha", id: "766602231V", image: "CO3.jpg" },
  { name: "Clara Jeniffer Direkx", id: "806594431V", image: "CO4.jpg" },
  { name: "Dilini D. Kumari Ekanayake", id: "", image: "CO5.jpg" },

  { name: "G.W. Hemantha Dharmapriya", id: "622401045V", image: "CO7.jpg" },
  { name: "Gamani Duruge", id: "", image: "CO8.jpg" },
  { name: "Gayani Supipi Balasuriya", id: "805840617V", image: "CO9.jpg" },
  { name: "J.A. Jayasinghe", id: "913304985V", image: "CO11.jpg" },
  { name: "K. Asanka Erandi Siriwardena", id: "805531169V", image: "CO12.jpg" },

  { name: "Kumari Ratnayake", id: "755522171V", image: "CO13.jpg" },
  { name: "M.D. Samudika Weerarathna", id: "", image: "CO14.jpg" },
  { name: "M.D. Samudika Weerarathna", id: "765732433V", image: "CO15.jpg" },
  { name: "P.W. Vajira", id: "666711408V", image: "CO17.jpg" },
  { name: "R.H. Namali", id: "826851635V", image: "CO18.jpg" },

  { name: "Rasika Nilanthi Thalansuriya", id: "705652813V", image: "CO19.jpg" },
  { name: "H.D. Deshamini Amarasinghe", id: "966920050V", image: "CO24.jpg" },
  { name: "S. Thilak Handunge", id: "770901669V", image: "CO25.jpg" },
  { name: "B.l. Thushan Chathuranga Kumarasiri", id: "", image: "CO28.jpg" },
  { name: "B.M. Sajeewanie", id: "", image: "CO29.jpg" },

  { name: "Chintha Kariyapperuma", id: "", image: "CO30.jpg" },
  { name: "D.B.R. Thanuja Wijayananda", id: "", image: "CO31.jpg" },
  { name: "D Indika Wikramasuriya", id: "791101808V", image: "CO32.jpg" },
  { name: "G. R. L. U. Gamlath", id: "", image: "CO33.jpg" },
  { name: "H. D. Kumuduni Silva", id: "", image: "CO34.jpg" },

  { name: "H. M. P. Liyanage", id: "", image: "CO35.jpg" },
  { name: "I. A. Rochana Sri lal Perera", id: "", image: "CO36.jpg" },
  { name: "J. A. Lasantha Deepal", id: "", image: "CO37.jpg" },
  { name: "J. A. N. K. Amarasinghe", id: "", image: "CO38.jpg" },
  { name: "Jayasinghe Arachchige Kosala", id: "", image: "CO39.jpg" },

  { name: "K. A. Chathuni Denuwanthi", id: "", image: "CO40.jpg" },
  { name: "K. P. Dimuthu Kumari", id: "", image: "CO41.jpg" },
  { name: "M. Ameen Jinnah", id: "", image: "CO42.jpg" },
  { name: "M. D. Chaturi Indika", id: "", image: "CO43.jpg" },
  { name: "M. Dilani Rukmal Perera", id: "", image: "CO44.jpg" },

  { name: "M. Sarath D. Pathiraja", id: "", image: "CO46.jpg" },
  { name: "N. Ajith Thalagala", id: "", image: "CO48.jpg" },
  { name: "Nethagi C. M. Weerasuriya", id: "", image: "CO49.jpg" },
  { name: "O. G. Dinesh Indika", id: "", image: "CO50.jpg" },
  { name: "O. L. A. Gamage Rasika Lakmali", id: "", image: "CO51.jpg" },

  { name: "O. Sameera Prasad De Silva", id: "", image: "CO52.jpg" },
  { name: "P. Asha Thilini Rajakurana Pavuluge", id: "", image: "CO53.jpg" },
  { name: "Piyadasa Kaltotage", id: "", image: "CO54.jpg" },
  { name: "R. A. Dimuthu P. Jayasena", id: "891243987V", image: "CO55.jpg" },
  { name: "R. D. D. Aruna santha Rankoth", id: "", image: "CO56.jpg" },

  { name: "R. L. Suren Perera", id: "", image: "CO57.jpg" },
  { name: "S. M. Anil Indika Bandara", id: "", image: "CO58.jpg" },
  { name: "Samantha Jayaweera", id: "", image: "CO59.jpg" },
  { name: "T. Saman Palitha", id: "", image: "CO60.jpg" },
  { name: "Thenuja Wijenanda", id: "", image: "CO61.jpg" },

  { name: "W. A. Jinadari Lalani De Silva", id: "", image: "CO62.jpg" },
  { name: "W. N. Rasika Fernando", id: "", image: "CO63.jpg" },
  { name: "W. Ruwan Janaka", id: "", image: "CO64.jpg" },
  { name: "Y. B. K. Chamlaka", id: "", image: "CO65.jpg" },
  { name: "M.S.N.Sameeraah", id: "", image: "CO66.jpg" },

  { name: "A. A Prabha A. Perera", id: "807903985V", image: "CO67.jpg" },

  // Certificate in Optician Alumni
 
  { name: "B.A. Sandun Indrajith", id: "", image: "CDO2.jpg" },
  {name: "D. Maneesha Wathukarage", id:"766602231V", image: "CDO3.jpg"},
  { name: "D. Shinal J.J. Subasinghe", id: "806594431V", image: "CDO4.jpg" },
  { name: "H.K.G. Eranda Nadeeshan Priyananda", id: "912142884V", image: "CDO5.jpg" },
  { name: "K.D. Nayani Fernando", id: "", image: "CDO6.jpg" },

  { name: "K. Indika Tushitha Kumarage", id: "", image: "CDO7.jpg" },
  { name: "M. Arshad Asker", id: "", image: "CDO8.jpg" },
  { name: "M.D. Ruwani Dilrukshi", id: "877650839V", image: "CDO9.jpg" },
  { name: "M.I. Subramaniam", id: "767641516V", image: "CDO10.jpg" },
  { name: "M.I. Ziyath", id: "", image: "CDO11.jpg" },

  { name: "M.P.L. Sudarshika Fernando", id: "661830719V", image: "CDO12.jpg" },
  { name: "M. Sameel", id: "", image: "CDO13.jpg" },
  { name: "M.V.A. Sarath Kumara", id: "", image: "CDO14.jpg" },
  { name: "N.P.I.G. Gunasekara", id: "", image: "CDO15.jpg" },
  { name: "N.W.M.S. Weerasekara", id: "", image: "CDO16.jpg" },

  { name: "P.G.P. Hemantha", id: "", image: "CDO17.jpg" },
  { name: "P.M. Chandani Senarathne", id: "", image: "CDO18.jpg" },
  { name: "P.R.D. Rathnayaka", id: "", image: "CDO19.jpg" },
  { name: "Ragupathy Maheswaran", id: "", image: "CDO20.jpg" },
  { name: "T. Pirhalathan", id: "", image: "CDO21.jpg" },

  { name: "W.G. Lal Premarathna", id: "", image: "CDO22.jpg" },
  { name: "Weerathunga Arachchi T. Dilhani", id: "871751480V", image: "CDO23.jpg" },
  { name: "A. G. K. Sarojani Ranatunga", id: "", image: "CDO24.jpg" },
  { name: "Ahmed Nafiz", id: "", image: "CDO25.jpg" },
  { name: "Amandi E. Udeshi Perera", id: "", image: "CDO26.jpg" },

  { name: "B. I. Musaffer", id: "", image: "CDO27.jpg" },
  { name: "Dayananda Vithanage", id: "", image: "CDO29.jpg" },
  { name: "Duleeka Jeewanthi Dahanayaka", id: "", image: "CDO30.jpg" },
  { name: "G. G. Madushani", id: "", image: "CDO31.jpg" },
  { name: "H. A. S. Sewwandi Perera", id: "", image: "CDO32.jpg" },

  { name: "H. K. Deepathica H. De Silva", id: "", image: "CDO33.jpg" },
  { name: "H. MALINDI DEWANDINI PERERA", id: "", image: "CDO34.jpg" },
  { name: "H. T. Sudeera Swarnamali Gunasinghe", id: "", image: "CDO35.jpg" },
  { name: "Indunil Sandaruwan Dahanayaka", id: "", image: "CDO37.jpg" },
  { name: "J. m. d. N. Dilrukshi", id: "", image: "CDO38.jpg" },

  { name: "K. M. CHANDANA S. BANDARA", id: "", image: "CDO39.jpg" },
  { name: "K. M. SHERON NIRASHA METHEW", id: "", image: "CDO40.jpg" },
  { name: "K. M. T. P. Perera", id: "", image: "CDO41.jpg" },
  { name: "Krishan Dayalan", id: "", image: "CDO42.jpg" },
  { name: "Late R. M. P. G. Lakshan Rumesh", id: "", image: "CDO43.jpg" },

  { name: "Loreta Kulasekara", id: "", image: "CDO44.jpg" },
  { name: "M. F. Hakam", id: "", image: "CDO45.jpg" },
  { name: "M. G. D. Dilrukshi", id: "", image: "CDO46.jpg" },
  { name: "M. M. Mohamed Naazer", id: "", image: "CDO47.jpg" },
  { name: "M. Razeen", id: "", image: "CDO48.jpg" },

  { name: "M. V. G. Maneesha pawan gunasekara", id: "", image: "CDO49.jpg" },
  { name: "PRIYANKA GANESHALINGAM", id: "", image: "CDO51.jpg" },
  { name: "R A D Sameera G Appuhamy", id: "", image: "CDO52.jpg" },
  { name: "R. M. S. Dhayodhya Rathnayake", id: "", image: "CDO53.jpg" },
  { name: "Shanika Thushani", id: "", image: "CDO55.jpg" },

  { name: "Shanthi Lal Chakma", id: "", image: "CDO56.jpg" },
  { name: "Shiyamalan Ganeshan", id: "", image: "CDO57.jpg" },
  { name: "Late Siva Gnanapandithen", id: "", image: "CDO58.jpg" },
  { name: "T. N. Thuwan JAUFER", id: "", image: "CDO60.jpg" },
  { name: "W. D. I. Harsana Dayananda", id: "", image: "CDO61.jpg" },

  { name: "W. D. kumari Dilinika", id: "", image: "CDO62.jpg" },
  { name: "Z. mohamed Sajee", id: "", image: "CDO63.jpg" },
  { name: "Zoona Mohamad", id: "", image: "CDO64.jpg" },

  



];

const Alumni = () => {
  const sections = [
    {
      title: "Diploma in Optometry",
      alumni: alumniData.slice(0, 35), // First 30 alumni

    },
    {
      title: "Certificate in Optometry",
      alumni: alumniData.slice(35, 91), // Next 62 alumni
    },
    {
      title: "Certificate in Optician",
      alumni: alumniData.slice(91, 149), 
    },

  ];

  return (
    <>
      {sections.map((section, index) => (
        <div className="alumni-container" key={index}>
          <h1>{section.title}</h1>
          <div className="alumni-grid">
            {section.alumni.map((alumni, idx) => (
              <div className="alumni-card" key={idx}>
                <img src={alumni.image} alt={alumni.name} />
                <h3>{alumni.name}</h3>
                <p>{alumni.id}</p>
              </div>
            ))}
          </div>
        </div>
      ))}
    </>
  );
};

export default Alumni;
